<!-- Print Button -->
@if (showPrintButton) {
  <div class="mb-6 max-w-md mx-auto">
    <button
      (click)="printQRCode()"
      class="w-full bg-blue-500 hover:bg-blue-600 text-white font-medium py-3 px-4 rounded-lg transition-colors flex items-center justify-center space-x-2">
      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
      </svg>
      <span>QR-Code Karte drucken</span>
    </button>
  </div>
}

<!-- SVG QR Code Card -->
<div class="max-w-md mx-auto">
  @if (isLoading) {
    <div
      class="flex items-center justify-center bg-gray-50 rounded-xl border-2 border-dashed border-gray-300 p-8">
      <hlm-spinner class="text-[length:--spacing(8)]" />
    </div>
  }

  <!-- Error State -->
  @if (error) {
    <div class="flex items-center justify-center bg-red-50 rounded-xl border-2 border-red-200 p-8">
      <div class="text-center">
        <svg
          class="mx-auto h-8 w-8 text-red-400 mb-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
        </svg>
        <p class="text-sm text-red-600 font-medium">{{ error }}</p>
      </div>
    </div>
  }

  <!-- SVG Card Display -->
  @if (!isLoading && !error && safeCardSvg) {
    <div [innerHTML]="safeCardSvg" class="flex justify-center"></div>
  }

  <!-- Fallback if SVG doesn't render -->
  @if (!isLoading && !error && !safeCardSvg) {
    <div class="bg-gray-50 rounded-xl border-2 border-dashed border-gray-300 p-8">
      <div class="text-center text-gray-500">
        <svg class="mx-auto h-8 w-8 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
        <p class="text-sm font-medium">QR-Code wird vorbereitet...</p>
      </div>
    </div>
  }
</div>
